export default {
  'Watermark': 'Filigran',
  'Add Watermark Selection': 'Filigran Seçimi Ekle',
}